module.exports = __webpack_public_path__ + "img/727968196a674de10287d1531c27f38a.jpg";